import { ActionFunctionArgs } from 'react-router-dom';
import { destroyProvider } from '@/common/api';
import { ApiError } from '@/common/types/errors';

export async function action({ params }: ActionFunctionArgs) {
  if (!params.providerId) {
    return {
      success: false,
      flash: {
        type: 'danger',
        message: 'Missing provider ID.',
      },
    };
  }

  try {
    await destroyProvider(Number(params.providerId));
    return {
      success: true,
      flash: {
        type: 'success',
        message: 'Provider deleted successfully.',
      },
    };
  } catch (error: unknown) {
    return {
      success: false,
      flash: {
        type: 'danger',
        message:
          error instanceof ApiError
            ? error.message
            : 'Failed to delete provider.',
      },
    };
  }
}
